import EnvironmentService from "../services/EnvironmentService.js";
const isUsingWPSWorkspace = () => {
  return EnvironmentService.getWpsStatus().needRequestToProxy === true;
};
const isUsingWPSWorkspaceAndProxyEnabled = () => {
  return isUsingWPSWorkspace() && EnvironmentService.getWpsStatus().workspaceProxyEnabled === true || EnvironmentService.useWPSProxy();
};
const isUsingWPSWorkspaceAndProxyDisabled = () => {
  return isUsingWPSWorkspace() && EnvironmentService.getWpsStatus().workspaceProxyEnabled === false;
};
const appendWPSFlagIfNeeded = (originUrl) => {
  if (!originUrl) {
    return "";
  }
  if (isUsingWPSWorkspaceAndProxyEnabled()) {
    return EnvironmentService.setTreatmentQueryParam("enableWPS", "true", originUrl);
  }
  return originUrl;
};
const transformPathToId = (path) => {
  var id = path.toLowerCase();
  const searchRegExp = /\//g;
  const replaceWith = "~";
  id = id.replace(searchRegExp, replaceWith);
  if (id.startsWith("~")) {
    id = id.substring(1);
  }
  if (id.endsWith("~") && id.length > 1) {
    id = id.substring(0, id.length - 1);
  }
  var pattern = new RegExp("[^a-z0-9~]", "g");
  id = id.replace(pattern, "");
  return id;
};
export {
  appendWPSFlagIfNeeded,
  isUsingWPSWorkspace,
  isUsingWPSWorkspaceAndProxyDisabled,
  isUsingWPSWorkspaceAndProxyEnabled,
  transformPathToId
};
//# sourceMappingURL=WPSUtils.js.map
